import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
  standalone: true
})
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeResourceUrl {
    if (url.includes('youtube.com')) {
      // Convert regular YouTube URLs to embed URLs
      url = url.replace('watch?v=', 'embed/');
      // Remove any playlist parameters
      url = url.split('&')[0];
    } else if (url.includes('vimeo.com')) {
      // Convert Vimeo URLs to embed URLs
      const vimeoId = url.split('/').pop();
      url = `https://player.vimeo.com/video/${vimeoId}`;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
